export function host() {
  const { host, href } = window.location;
  const protocol = href.indexOf('https') !== -1 ? 'https://' : 'http://';
  // const protocol = 'https://';
  // const host = window.location.host;

  if(host.indexOf('localhost') != -1 || host.indexOf('127.0.0.1') != -1){
    // return protocol+'api-en-vpgl.7mdt.com/api/';
    return protocol + 'rx-zhongxiaoqiyeshuzihuazhuanxingfuwu.test.sportsdt.cn/api/';
  }
  if(host.indexOf('.dev') != -1){
    return protocol + 'rx-zhongxiaoqiyeshuzihuazhuanxingfuwu.dev.sportsdt.cn/api/';
  }
  if(host.indexOf('.test') != -1){
    return protocol + 'rx-zhongxiaoqiyeshuzihuazhuanxingfuwu.test.sportsdt.cn/api/';
  }
  if(host.indexOf('.staging') != -1){
    return protocol + 'rx-zhongxiaoqiyeshuzihuazhuanxingfuwu.staging.sportsdt.cn/api/';
  }
  return protocol + host + '/api/';
}

export function host1() {
  const { host, href } = window.location;
  const protocol = href.indexOf('https') !== -1 ? 'https://' : 'http://';
  // const protocol = 'https://';
  // const host = window.location.host;

  if(host.indexOf('localhost') != -1 || host.indexOf('127.0.0.1') != -1){
    // return protocol+'api-en-vpgl.7mdt.com/api/';
    return protocol + 'rx-zhongxiaoqiyefuwu.test.sportsdt.cn/api/api/index';
  }
  if(host.indexOf('.dev') != -1){
    return protocol + 'rx-zhongxiaoqiyefuwu.dev.sportsdt.cn/api/api/index';
  }
  if(host.indexOf('.test') != -1){
    return protocol + 'rx-zhongxiaoqiyefuwu.test.sportsdt.cn/api/api/index';
  }
  if(host.indexOf('.staging') != -1){
    return protocol + 'rx-zhongxiaoqiyefuwu.staging.sportsdt.cn/api/api/index';
  }
  return protocol + host + '/shaniqi-api/api/index';
}


// WEBPACK FOOTER //
// ./src/utils/host.js